import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { useLocation } from 'react-router-dom'
import { getSubmission } from 'services/api/modules/performance/appraisal/submission'
import RevieweesCard from '../components/revieweesCard'
import ReviewersCard from '../components/reviewersCard'
import TeamMemberCard from '../components/teamMemberCard'
import PageHeaderAppraisal from '../components/PageHeaderAppraisal'

const ViewSubmissionAppraisal = () => {
  const { state } = useLocation()
  const queryClient = useQueryClient()
  useEffect(() => {
    queryClient.invalidateQueries('allSubmissionData')
    queryClient.resetQueries('submissionData')
  }, [])
  const {
    isLoading,
    error: fetchError,
    data,
  } = useQuery(['submissionData', state.submissionId], async () => {
    const { data } = await getSubmission(state.submissionId)
    return data
  })
  return (
    <Box
      sx={{
        backgroundColor: 'gray-background.main',
        minHeight: '100vh',
        maxWidth: '100vw',
      }}
      display="flex"
      flexDirection="column"
    >
      <PageHeaderAppraisal evaluationTitle={state?.evaluationDetails?.evaluation_title} />
      <Grid container>
        <Grid item xs={8}>
          <Box display="flex" flexDirection="column" gap={2} p={3}>
            {data?.sections?.map((section, index) => (
              <Box
                display="flex"
                flexDirection="column"
                bgcolor="white.main"
                borderRadius={2}
                boxShadow="0px 0px 10px lightgray"
                key={index}
              >
                <Box px={3} py={2} borderBottom={1} borderColor="gray-line.main">
                  <Typography variant="h4" fontWeight="bold">
                    {section.title}
                  </Typography>
                </Box>
                {section?.questions?.map((question, index) => (
                  <Box display="flex" flexDirection="column" gap={1} px={3} py={2} key={index}>
                    <Typography>{question?.title}</Typography>
                    {question?.response ? (
                      <Typography
                        pl={2}
                        sx={{ fontStyle: 'italic' }}
                        dangerouslySetInnerHTML={{
                          __html: question?.response
                            ?.replace(/\\n/g, '<br />')
                            .replace(/\\t/g, '&nbsp;&nbsp;&nbsp'),
                        }}
                      />
                    ) : (
                      <Typography
                        pl={2}
                        variant="body1"
                        color="light-gray-text.main"
                        sx={{ fontStyle: 'italic' }}
                      >
                        No answer
                      </Typography>
                    )}
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        </Grid>

        <Grid item xs={4}>
          {state?.reviewerDetails ? (
            <ReviewersCard reviewerDetails={state?.reviewerDetails} status={state?.status} />
          ) : state?.revieweeDetails ? (
            <RevieweesCard revieweeDetails={state?.revieweeDetails} />
          ) : state?.teamMemberDetails ? (
            <TeamMemberCard
              isTeamMember={state?.isTeamMember}
              evaluationDetails={state?.evaluationDetails}
              teamMemberDetails={state?.teamMemberDetails}
              reviewerLength={state?.reviewerLength}
            />
          ) : null}
        </Grid>
      </Grid>
    </Box>
  )
}

export default ViewSubmissionAppraisal
